'StocktakeLine'.datatype()
'stocktakeNumber'.field({refersToParent: "Stocktake", parentIsHeader: true, hidden: true})
'product'.field({refersTo: "products"})
'sku'.field()
'wooCommerceRegularPrice'.field({numeric: true, decimals: 2, caption: 'WC Regular Price'})
'systemQuantity'.field({numeric: true})
'countedQuantity'.field({numeric: true})
'discrepancy'.field({numeric: true})

'discrepancy'.calculate(async stl => {
  return stl.countedQuantity - stl.systemQuantity
})

'wooCommerceRegularPrice'.calculate(async stl => {
  let p = await stl.toProduct(); if ( ! p ) return 0
  return p._regular_price
})

'countedQuantity'.afterUserChange((oldInputValue, newInputValue, stocktakeLine) => {
  stocktakeLine.countEntered = (newInputValue !== '')
})

'sku'.calculate(async stl => {
  let p = await stl.toProduct(); if ( ! p ) return ''
  return p._sku
})

'StocktakeLine'.method('toProduct', async function() {
  return await this.referee('product')
})

'StocktakeLine'.method('toInventory', async function() {
  let product = await this.toProduct(); if ( ! product ) return null
  return await product.toInventory()
})

